import React, { useEffect, useRef, useState } from 'react'
import Popup from '../../ReusableFunctions/Popup'
import Loading from '../../ReusableFunctions/Loader'
import MainContentWrapper from '../../Components/MainContentWrapper'
import { getAllUsers } from '../../apis/adminAPIs/users'
import ViewUser from './SubComponents/ViewUser'
import TableView from '../../ReusableComponents/TableView/TableView'
import Search from '../../ReusableComponents/Search'
import _debounce from 'lodash/debounce';
import UsersFilter from './SubComponents/UsersFilter'
import { Button } from '../../Components/Helper'
import { generateCSV } from '../../utils/generateAndDownloadCsv'
import { useLocation, useNavigate } from 'react-router'
import InteractiveGraph from '../../BhuMeetTeams/BhuMeetFinance/Orders/SubComponents/OrdersGraph'
import { PDRL_ADMIN_ROUTES, PDRL_SUCCESS_ENGI_ROUTES } from '../../routes'
const PAGE_SIZE = 15

const csvHeader = [
    { label: "Name", key: "name" },
    { label: "Phone Number", key: "mobile_number" },
    { label: "State", key: "state" },
    { label: "Language Preference", key: "language_preference" },
    { label: "Created Date", key: "date_created", isDate: true },
    { label: "Total_spraying_requests", key: "spraying_requests" },
    { label: "Total_survey_requests", key: "survey_requests" },
]

const Users = () => {
    const isFirstRender = useRef(true);
    const [loading, setLoading] = useState()
    const [users, setUsers] = useState([])
    const [userCount, setUserCount] = useState(0)
    const { pathname } = useLocation();
    const [currentPage, setCurrentPage] = useState(() => {
        const currentPage = localStorage.getItem('currentUserPage')
        if (currentPage) {
            const parseCurrentPage = JSON.parse(currentPage)
            return parseCurrentPage;
        }
        return 1;
    }
    )
    const [selectedUser, setSelectedUser] = useState()
    const [requestsGraphData, setrequestsGraphData] = useState([])
    const [openFilter, setOpenFilter] = useState(false)
    const [searchString, setSearchString] = useState("")
    const [filter, setFilter] = useState(() => {
        const savedFilters = localStorage.getItem('userPageFilters')
        if (savedFilters) {
            const parsesavedFilters = JSON.parse(savedFilters)
            return parsesavedFilters;
        }
        return {
            fromDate: null,
            toDate: null,
            states: [],
        }
    })
    const navigate = useNavigate();

    const getAllUsersFunc = async () => {
        try {
            setLoading(true)
            const { fromDate, toDate, states } = filter
            getAllUsers(PAGE_SIZE, currentPage, searchString, fromDate, toDate, states).then(users => {
                Loading.set(false)
                setLoading(false)
                setUsers(users?.allUsers)
                setUserCount(users.count || 0)
                setrequestsGraphData(users.allUsersstats)
            })
        } catch (err) {
            setLoading(false)
            Loading.set(false)
            Popup("Error", err, "ERROR")
        }
    }

    const downloadCSV = async () => {
        Loading.set(true)
        const { fromDate, toDate } = filter
        const users = await getAllUsers(PAGE_SIZE, currentPage, searchString, fromDate, toDate)
        generateCSV(csvHeader, users?.allUsers, "output")
        Loading.set(false)
    }

    useEffect(() => {
        Loading.set(true)
        setLoading(true)
        localStorage.removeItem("userDetailsPageFilters")
        getAllUsersFunc()
    }, [])

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        localStorage.setItem("userPageFilters", JSON.stringify(filter));
        localStorage.setItem("currentUserPage", JSON.stringify(currentPage))

        const debouncedGetAllUsers = _debounce(() => {
            getAllUsersFunc();
        }, 2000);

        debouncedGetAllUsers();

        return () => {
            debouncedGetAllUsers.cancel();
        };
    }, [searchString, currentPage, filter]);
    return (

        <MainContentWrapper
            leftContent={`Users (${userCount})`}
            rightContent={
                <div style={{ display: "flex", alignItems: "end", gap: "30px" }}>
                    <Search
                        searchValue={searchString}
                        onChange={(value) => {
                            setLoading(true);
                            setSearchString(value)
                            setCurrentPage(1)
                        }}
                        height={"45px"}
                    />
                    <UsersFilter
                        filter={filter}
                        open={openFilter}
                        onClose={() => setOpenFilter(false)}
                        onFilterChange={(filter) => {
                            setCurrentPage(1);
                            setFilter(filter)
                        }}
                        loading={loading}
                        setOpenFilter={setOpenFilter}
                    />
                    {/* <Button
                        text={"Export CSV"}
                        style={{ width: "140px", height: "38px", fontSize: "15px" }}
                        onClick={() => {
                            downloadCSV()
                        }}
                    /> */}
                </div>
            }
        >
            <InteractiveGraph
                showZoom
                data={requestsGraphData}
                lineType={0}
            />
            <TableView
                isLoading={loading}
                tableContainerHeight={userCount < 15 ? "calc(100% - 40px)" : "calc(100% - 65px)"}
                showSrNo
                onStateChange={(changedState) => {
                    setLoading(true);
                    setCurrentPage(changedState.pageNumber)
                }}
                onClickRow={(user) => {
                    localStorage.setItem("dsp_id", user.id)
                    setSelectedUser(user)
                    navigate(PDRL_ADMIN_ROUTES.CSEUSERDETAILS, { state: { user: user } });
                }}
                onClickLink={(request) => { }}
                columns={[
                    { Header: "Name", accessor: "name", width: "15%" },
                    { Header: "Phone number", accessor: "mobile_number", width: "15%", },
                    { Header: "Language Preference", accessor: "language_preference", width: "10%" },
                    { Header: "State", accessor: "state", width: "15%" },
                    // { Header: "District", accessor: "district", width: "15%" },
                    // { Header: "Taluka", accessor: "taluka", width: "15%" },
                    { Header: "Created date", accessor: "date_created", width: "10%", isDate: true },
                    { Header: "Dsp Name", accessor: "dsp_name", width: "10%" },
                    { Header: "Source", accessor: "source", width: "10%" },
                    { Header: "Status", accessor: "user_active_label", showColor: true, width: "10%" },
                ]}
                data={users.map((u) => {
                    return (
                        {
                            ...u,
                            user_active_label: u.is_active ? "Active" : "Inactive",
                            color: u.is_active ? 'green' : 'red'
                        }
                    )
                })}
                count={userCount}
                pageNumber={currentPage}
                pageSize={PAGE_SIZE}
            />
        </MainContentWrapper>
    )
}

export default Users